/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, {useEffect , useState, useCallback} from 'react'
import { motion } from 'framer-motion'
import { distributorService } from '../../service/distributor.service'
import { generateDateWithTime } from '../../redux/helper/DateConverter'
import { Link } from 'react-router-dom'
import Pagination from '../../Components/Pagination'
import EmptyOrderPage from '../MyOrders/EmptyOrderPage'

const SubscribedOfferListing = ({tab, setTab, filterQuery, setFilterQuery, subscription, setSubscription, loading, currentPage, totalPage, handlePageClick, alldata,emptyData,searchValue }) => {
    // const [subscription, setSubscription] = useState([])
    // const [filterQuery, setFilterQuery] = useState({page:1,limit:10,sort:"created_at asc"})

    // const handleFetch = useCallback(
    //     async(filter) => {
    //         const filterString = new URLSearchParams(filter).toString()
    //         const subscription = await distributorService.SubscriptionList(filterString);
    //         if(!subscription.error && subscription.data.data.success_status){
    //             setSubscription(subscription.data.data.Items)         
    //         }
    //     },
    //     [],
    // )

    // const handleFilter = (value, key) => {
    //     filterQuery[key] = value;
    //     setFilterQuery(filterQuery);
    //     handleFetch(filterQuery);
    // };

    // useEffect(() => {
    //     handleFetch(filterQuery)
    // }, [])
    return (
        <div className={`tab-pane ${tab === 'subscribed_offer' ? 'show active' : ''} fade`} id="pillcategorie" role="tabpanel" aria-labelledby="pills-categories">       
            {subscription && subscription.length > 0 && subscription.map((sub, subIndex) => (
                <motion.div 
                    animate={{ opacity: 1, x: 0 }}
                    initial={{ opacity: 0, x: -10 }}
                    exit={{ opacity: 0, x: -10 }}
                    transition={{ duration: 0.15 }} 
                    key={subIndex}
                    className="w-full rounded-[10px] shadow-s16 px-3.5 sm:pt-[17px] pt-4 pb-5 mb-2"
                >
                    <div className="relative ">
                        <div className="">
                            <div className="flex items-start justify-between md:flex-nowrap flex-wrap">
                                <div className="flex items-center sm:flex-nowrap flex-wrap md:w-[60%] w-full">
                                    <motion.img
                                        className="box"
                                        initial={{ opacity: 0, scale: 0.5 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{
                                            duration: 0.8,
                                            delay: 0.5,
                                            ease: [0, 0.71, 0.2, 1.01]
                                        }}
                                        src="images/related-offer.svg" alt="icon"/>
                                    <div className="sm:pl-5 w-full">
                                        <ul className="sm:mt-0 mt-2">
                                            <li className="font-semibold sm:text-sm10 text-xl text-[#090406] break-words">{sub.subscription_id} <span className="pl-[6px] text-xs13 font-normal text-[#44445E]"> Subscribed On: {generateDateWithTime(Number(sub.created_at))} </span></li>
                                            <div className='flex'>
                                                <li className="text-sm41 font-semibold text-[#44445E]">{sub.offer_code}</li>
                                                <p className="text-xs font-semibold text-[#FFFFFF] bg-[#44445E] rounded px-1.5 py-1 w-fit ml-2">{sub.offer.industrial_pocket}</p>
                                            </div>
                                            <li className="text-[#44445E] font-normal text-xs13 my-[6px]">Validity: {sub.offer.start_date} to {sub.offer.end_date}<span className="px-2">|</span><span className="font-semibold">{sub.offer.offer_value}</span></li>
                                            <li>
                                                <div className="sm:py-3 py-2.5 sm:px-5 px-3 rounded-lg bg-[#E9EDF4]">
                                                    <p className="text-sm font-bold text-[#808285] mb-3">Progress</p>
                                                    <div className="flex justify-center items-center">
                                                        <div x-data="range()" x-init="mintrigger(); maxtrigger()" className="relative w-full">
                                                            <div>
                                                                <div className="relative z-[6] h-2.5 w-full">
                                                                    <div className="absolute z-[6] left-0 right-0 bottom-0 top-0 rounded-md bg-white">
                                                                        <div className="h-2.5 absolute left-0 top-0 bg-[#555259] rounded-md" style={{width: `${sub.fulfillment_percentage <= 100? `${sub.fulfillment_percentage}` : '100'}%`}}></div> 
                                                                    </div>
                                                                    <div className="absolute z-20 top-0 bottom-0 rounded-md bg-[#BBF8C9]"></div>
                                                                    <div className="absolute z-30 w-2.5 h-2.5 top-2 right-0 bg-[white] border-2 border-[#18BB5D] rounded-full -mt-2"></div>
                                                                </div>
                                                            </div>    
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li className="text-[#44445E] font-normal text-sm49 pt-4">{sub.offer.description}</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="flex flex-col md:mt-14 mt-5 md:ml-8 ml-0 self-end md:w-[40%] w-full">
                                    <div className="bg-[#E9EDF4] rounded-lg p-[2px]">
                                        <div className="bg-[#ffffff] px-[15px] py-3 rounded-lg">
                                            <p className="text-sm42 font-semibold text-[#808285] pb-2.5">Order List</p>
                                            {sub.orders.reverse().slice(0, 3).map((order,orderIndex) => (
                                                <div className="flex items-center" key={`order-${orderIndex}`}>
                                                    <p className="w-1/2 text-sm37 font-normal text-[#090406]">{order.order_number}</p>
                                                    <p className="w-1/2 text-sm47 font-normal text-[#555259]">{generateDateWithTime(order.created_at)}</p>
                                                </div>
                                            ))}
                                            {sub.orders.length === 0 && <p className="w-1/2 text-sm37 font-normal text-[#090406]">Orders not placed yet</p>}
                                           
                                        </div>
                                        {sub.orders.length > 0 && (
                                            <div className="pt-[3px] pb-[5px]">
                                                <Link to={`/orders?subscription=${sub.subscription_id}`} className="text-sm35 font-semibold text-[#555259] w-full inline-block text-center">View All</Link>
                                            </div>
                                        )}
                                    </div>
                                    <Link to={`/bulk-offers/${sub.offer_code}/${sub.subscription_id}?code=${encodeURIComponent(sub.offer_code)}`} className="w-full mt-4">
                                        <motion.button 
                                            initial={{ opacity: 0, scale: 0.9 }}
                                            animate={{ opacity: 1, scale: 1 }}
                                            transition={{
                                                duration: 0.8,
                                                delay: 0.5,
                                                ease: [0, 0.71, 0.2, 1.01]
                                            }}
                                            type="button" 
                                            className="w-full h-10 rounded-lg bg-[#555259] font-semibold text-sm text-[#FFFFFF]">
                                            View Offer
                                        </motion.button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.div>))}

            {!loading && subscription && subscription.length > 0 && (
                <Pagination
                    handlePageClick={handlePageClick}
                    totalPage={totalPage}
                    List={alldata}
                    currentPage={currentPage}
                />
            )}
            {emptyData && <EmptyOrderPage search="yes" text="no Subscribed Offers" all={searchValue.length > 0 ? 'under searched term' : 'found'} />}

           
        </div>
    )
}

export default SubscribedOfferListing